import Navigation from './Navigation';
import React from 'react'
import styled from 'styled-components'

function Sidebar({navToggle}) {
    return (
        <SidebarStyled className={`${navToggle ? 'nav-toggler' : ''}`}>
            <Navigation />
        </SidebarStyled>
    )
}

const SidebarStyled = styled.div`
width: 1.5rem;
height: 100vh;
position: fixed;
transition: all .4s ease-in-out;
z-index: 30;
@media only screen and (max-width: 1200px){
    transform: translateX(-250%);
}
`;
export default Sidebar;
